export default {
  LOAD_LIST(state, data) {
    state.listItemProtocol = data
  },
  PREPARE_TO_EDIT(state, data) {
    state.itemProtocol = data
  },
}
